if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.addEventListener('pointerup', (event) => {
          if (this.hasAttribute('data-collage') && event.target.closest('[data-gallery-step]')) event.stopPropagation();
        }, true);
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-gallery-step]');
          if (button && this.hasAttribute('data-collage')) this.moveCollageMedia(Number(button.dataset.galleryStep));
        });
        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('data-collage') || !['ArrowLeft', 'ArrowRight'].includes(event.key) || event.target.closest('input, textarea, select, video, iframe, model-viewer')) return;
          event.preventDefault();
          this.moveCollageMedia(event.key === 'ArrowRight' ? 1 : -1);
        });
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      moveCollageMedia(direction) {
        const container = this.querySelector('[role="document"]');
        if (!container || ![-1, 1].includes(direction)) return;
        const items = Array.from(container.children).filter(item => item.hasAttribute('data-media-id'));
        if (!items.length) return;
        const index = items.reduce((nearest, item, i) =>
          Math.abs(item.offsetLeft - container.scrollLeft) < Math.abs(items[nearest].offsetLeft - container.scrollLeft) ? i : nearest, 0);
        const next = items[(index + direction + items.length) % items.length];
        window.pauseAllMedia();
        items.forEach(item => item.classList.toggle('active', item === next));
        container.scrollTo({left: next.offsetLeft, behavior: 'instant'});
        if (next.matches('deferred-media')) next.loadContent();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        const container = this.querySelector('[role="document"]');
        if (this.hasAttribute('data-collage')) {
          container.scrollLeft = activeMedia.offsetLeft;
        } else {
          activeMedia.scrollIntoView();
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
